export class ConfirmationDialogComponentData {
    title:string;
    message:string;
    yesText: string = "Igen";
    noText: string = "Nem";
}
